/**
 * @generated SignedSource<<287df9befea8abe6881685dc5199e07d>>
 * @relayHash ddaaf58d5be07e0aaeab7a35b0fda1a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15fe8fd719af36e930ba064fd20a39258370132923fb0e706532bfa7e04108f1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavPlansQuery } from './HorizontalNavPlansQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavPlansQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "15fe8fd719af36e930ba064fd20a39258370132923fb0e706532bfa7e04108f1",
    "metadata": {},
    "name": "HorizontalNavPlansQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
